import { maskString } from './Utils'

/**
 * @param {object} event 
 * @param {string} event.clientId 
 * @param {string} event.fsId 
 * @param {string} event.trackId
 * @param {string} event.eventType - 'SDK.WEB.GLBID.LOGOUT.REQUESTED' | 'SDK.WEB.OIDC.LOGOUT.REQUESTED'
 * @param {string} event.glbId 
 * @param {string} event.globoId 
 * @param {string} event.sdkVersion
 * @param {string} event.errorType
 * @param {boolean} event.isWebView
 * @param {string} event.sessionManagement
 * @param {boolean} event.legacyCompatible
 * @param {string} event.errorReason 
 */

const sendTrackEvent = async (event) => {
  if (!navigator.sendBeacon) {
    throw new Error('[GloboID.js - sendTrackEvent] navigator.sendBeacon is not supported')
  }

  if (!event.clientId || !event.eventType) {
    throw new Error('[GloboID.js - sendTrackEvent] missing clientId or eventType to send event')
  }

  // eslint-disable-next-line no-undef
  const url = `${TRACKID_SEND_EVENT_URL}`

  const glbId = maskString(event.glbId)
  const globoId = event.globoId

  const data = {
    clientId: event.clientId,
    eventType: event.eventType,
    versionSDK: event.sdkVersion,
    isWebView: event.isWebView,
    errorType: event.errorType,
    userAgent: navigator.userAgent,
    href: window.location.origin,
    sessionManagement: event.sessionManagement,
    legacyCompatible: event.legacyCompatible,
    ...(globoId && { globoId }),
    ...(glbId && { GLBID: glbId }),
    ...(event.fsId && { trackId: event.fsId }),
    ...(event.errorReason && { errorReason: event.errorReason }),
  }

  data.trackId = event.fsId || event.trackId

  const bodyRequest = JSON.stringify(data)

  const base64BodyRequest = window.btoa(bodyRequest)

  const success = navigator.sendBeacon(url, base64BodyRequest)

  if (!success) {
    throw new Error('[GloboID.js - sendTrackEvent] failed to send event')
  }

  return
}



export { sendTrackEvent }
